import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  token: string;
  id: number | null;
  username: string;
}

const initialState: UserState = {
  token: '',
  id: null,
  username: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<{ token: string; id: number; username: string }>) {
      state.token = action.payload.token;
      state.id = action.payload.id;
      state.username = action.payload.username;
    },
    logout(state) {
      state.token = '';
      state.id = null;
      state.username = '';
    },
  },
});

export const { setUserInfo, logout } = userSlice.actions;
export default userSlice.reducer;